// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  ImageField,
  ImageInput,
  SimpleList,
} from "react-admin";
import useWindowWidthBreakpoints from "use-window-width-breakpoints";

const AdFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="title" alwaysOn />
  </Filter>
);

export const AdList = (props) => {
  const breakpoint = useWindowWidthBreakpoints({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  });
  return (
    <List {...props} filters={<AdFilter />}>
      {breakpoint.down.sm ? (
        <SimpleList
          primaryText={(record) => record.title}
          tertiaryText={(record) =>
            new Date(record.createdate).toLocaleDateString()
          }
          linkType={(record) => (record.canEdit ? "edit" : "show")}
        />
      ) : (
        <Datagrid>
          <TextField source="title" />
          <TextField source="createdate" />
          <TextField source="lastupdate" />
          <ShowButton label="" />
          <EditButton label="" />
          <DeleteButton label="" redirect={false} />
        </Datagrid>
      )}
    </List>
  );
};

export const AdShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <ImageField source="file.src" title="file.title" />
      <TextField source="title" />
      <TextField source="url" />
      <TextField source="createdate" />
      <TextField source="lastupdate" />
    </SimpleShowLayout>
  </Show>
);

export const AdCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ImageInput
        source="file"
        label="image"
        accept="image/*"
        validation={{ required: true }}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
      <TextInput source="title" validation={{ required: true }} />
      <TextInput source="url" validation={{ required: true }} />
    </SimpleForm>
  </Create>
);

export const AdEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ImageInput
        source="file"
        label="image"
        accept="image/*"
        validation={{ required: true }}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
      <TextInput source="title" validation={{ required: true }} />
      <TextInput source="url" validation={{ required: true }} />
    </SimpleForm>
  </Edit>
);
